export default __webpack_public_path__ + "static/media/developing-an-ask.46d0b819.png";